<template>
	<i :class="classes"/>
</template>

<script>
	export default {
		props: {
			name: {
				type: String
			}
		},
		computed: {
			fontName(){
				let split = this.name.split(".");
				return split.length !== 2 ? this.name : split[1];
			},
			fontFamily(){
				let split = this.name.split(".");
				return split.length !== 2 ? "fa" : split[0];
			},
			classes(){
				return `${this.fontFamily} ${this.fontFamily}-${this.fontName}`;
			}
		}
	}
</script>

<style >

</style>
